const NUM_WHATSAPP = 1;

export default {
  NUM_WHATSAPP
};
